const basePath = '/book-stack';

export class BookStackPath {
  static index() {
    return basePath;
  }
}
